<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left>
    <h2 class="title">Bulk External Transactions</h2>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right>
    <button
      #searchPopoverComponent="ngbPopover"
      nf-button="primary"
      ngbTooltip="Search for External Transactions to Download"
      placement="auto"
      autoClose="outside"
      container="body"
      popoverClass="find-transactions-popover"
      [ngbPopover]="popoverContent"
      (shown)="onSearchPopoverShown()"
      (hidden)="onSearchPopoverHidden()"
    >
      Find Transactions
    </button>
    <ng-template #popoverContent>
      <ng-content></ng-content>
    </ng-template>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right class="clear-filters-button">
    <button
      nf-button="cancel"
      [title]="cancelRequestTitle"
      [disabled]="!isLoading"
      (click)="onCancelRequest()"
    >
      Cancel Request
    </button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right class="clear-filters-button">
    <button
      class="m-0"
      icon="filter-remove"
      nf-icon-button="secondary"
      ngbTooltip="Clear Table"
      placement="bottom-right"
      container="body"
      (click)="clearFilters()"
      [disabled]="data.length === 0"
    >
      Clear Table
    </button>
  </ng-grid-wrapper-header-right>

  <nf-grid-wrapper-content
    id="bulk-ext-tx-limit-exceeded-alert"
    *ngIf="transactionsLimitExceeded"
  >
    <ngb-alert [dismissible]="false">
      <strong>Data may be incomplete! </strong> More than
      {{ data.length }} transactions found, please narrow down your search to
      receive the complete list.
    </ngb-alert>
  </nf-grid-wrapper-content>
  <nf-grid-wrapper-content>
    <nf-table-layout
      [hideTitle]="true"
      [isSectionTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [autoResizeGrid]="false"
      [data]="data"
      hideSearch
      hideClearAll
      *nfLoader="isLoading"
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
